import React, { useState } from 'react';
import usePresence from '../use/usePresence';
import Aviso from './ui/Aviso';
import { Link } from 'react-router-dom';
import { FileText } from 'phosphor-react';
import PrimaryButton from './buttons/PrimaryButton';

interface TermsGateProps {
  aberto: boolean;
  onAccept: () => void;
  loading: boolean;
  error: string;
}

/**
 * Portão de aceite dos Termos para contas anteriores a eles. Não usa o ActionModal de
 * propósito: aquele fecha no X e no clique fora, e um aceite que se fecha sozinho não é
 * aceite — daqui só se sai marcando o checkbox.
 */
export default function TermsGate({ aberto, onAccept, loading, error }: TermsGateProps) {
  const [marcado, setMarcado] = useState<boolean>(false);
  const { montado, estado } = usePresence(aberto, 200);

  if (!montado) return null;

  return (
    <div
      data-state={estado}
      className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center p-4 data-[state=closed]:pointer-events-none"
    >
      <div
        data-state={estado}
        className="fixed inset-0 bg-black/40 backdrop-blur-sm data-[state=open]:animate-fade-in data-[state=closed]:animate-fade-out"
        aria-hidden="true"
      />

      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="terms-gate-title"
        data-state={estado}
        className="relative w-full max-w-md bg-white dark:bg-gray-800 rounded-t-2xl sm:rounded-2xl shadow-soft-lg dark:shadow-none dark:border dark:border-gray-700 p-6 data-[state=open]:animate-sheet-in data-[state=closed]:animate-sheet-out sm:data-[state=open]:animate-scale-in sm:data-[state=closed]:animate-scale-out"
      >
        <div className="w-12 h-12 mb-4 bg-sage-100 dark:bg-sage-900/30 rounded-2xl flex items-center justify-center">
          <FileText className="w-6 h-6 text-sage-500" />
        </div>

        <h2 id="terms-gate-title" className="text-lg font-semibold text-gray-800 dark:text-gray-100">
          Nossos Termos de Serviço
        </h2>
        <p className="mt-2 text-sm text-nude-500 dark:text-gray-400">
          Para continuar usando o AutoCare, precisamos do seu aceite. Leva um minuto.
        </p>

        <label className="mt-5 flex items-start gap-2.5 cursor-pointer">
          <input
            type="checkbox"
            checked={marcado}
            onChange={(e) => setMarcado(e.target.checked)}
            className="mt-0.5 w-4 h-4 rounded border-nude-300 dark:border-gray-600 text-blush-500 focus:ring-blush-500 cursor-pointer"
          />
          <span className="text-xs leading-relaxed text-nude-500 dark:text-gray-400">
            Tenho 18 anos ou mais e li e concordo com os{' '}
            <Link
              to="/termos"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blush-500 font-semibold hover:text-blush-600 transition-colors"
            >
              Termos de Serviço
            </Link>{' '}
            e a{' '}
            <Link
              to="/privacidade"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blush-500 font-semibold hover:text-blush-600 transition-colors"
            >
              Política de Privacidade
            </Link>
          </span>
        </label>

        <Aviso mensagem={error} className="mt-3" />

        <div className="mt-5">
          <PrimaryButton fullWidth disabled={!marcado} loading={loading} onClick={onAccept}>
            Continuar
          </PrimaryButton>
        </div>

        <div className="h-[env(safe-area-inset-bottom)] sm:hidden" />
      </div>
    </div>
  );
}
